import { gql } from '@apollo/client';

export const START_WORKATO_RECIPE_MUTATION = gql`
  mutation StartWorkatoRecipeMutation($solutionInstanceId: String!) {
    startWorkatoRecipe(solutionInstanceId: $solutionInstanceId) {
      success
    }
  }
`;
